export const formatDatePart = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${month}.${day}`;
};

export const calculateDTE = (dateString) => {
    if (!dateString) return 'N/A';
    const today = new Date();
    const expirationDate = new Date(dateString);
    today.setHours(0, 0, 0, 0);
    expirationDate.setHours(0, 0, 0, 0);
    const diffTime = expirationDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};

export const formatLegSimple = (leg) => {
    if (!leg) return 'N/A';
    return `${leg.strike}${leg.opt === 'CALL' ? 'C' : 'P'}`;
};

export const formatSpread = (spread, type, quantity) => {
    if (!spread || !spread.legs || spread.legs.length < 2) return 'Invalid Spread Data';
    const leg1 = spread.legs[0]; 
    const leg2 = spread.legs[1];

    let display;
    if (type === 'calendar') {
        display = `${leg1.strike}`;
    } else if (type === 'diagonal') {
        const diff = Number(leg2.strike) - Number(leg1.strike);
        if (Number.isFinite(diff)) {
            const sign = diff >= 0 ? '+' : '-';
            display = `${leg1.strike}/${sign}${Math.abs(diff)}`;
        } else {
            display = `${leg1.strike}/${leg2.strike}`;
        }
    } else if (type === 'vertical') {
        const diff = Number(leg1.strike) - Number(leg2.strike);
        if (Number.isFinite(diff)) {
            const sign = diff >= 0 ? '+' : '-';
            display = `${leg2.strike}/${sign}${Math.abs(diff)}`;
        } else {
            display = `${leg2.strike}/${leg1.strike}`;
        }
    } else {
        display = `${formatLegSimple(leg1)} / ${formatLegSimple(leg2)}`;
    }
    let qtyLabel = '';
    if (type === 'calendar' && quantity && quantity > 1) {
        qtyLabel = `${quantity}x `;
    } else if (type === 'diagonal' && quantity && quantity > 1) {
        qtyLabel = `${quantity}x `;
    }
    return `${qtyLabel}${display}`; 
};

export const formatFinancialValueCell = (value, multiply = false, digits = 2, hideZeroDecimals = false) => {
    let numValue = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(numValue)) return (value !== null && value !== undefined ? String(value) : 'N/A');
    if (multiply) {
        numValue *= 100;
    }
    const factor = Math.pow(10, digits);
    let roundedValue = Math.round(numValue * factor) / factor;
    if (digits === 0 && Object.is(roundedValue, -0)) {
        roundedValue = 0;
    }
    
    // If it's a whole number and hideZeroDecimals is true, we hide the .00
    const minDigits = (hideZeroDecimals && roundedValue % 1 === 0) ? 0 : digits;

    return roundedValue.toLocaleString('en-US', { 
        minimumFractionDigits: minDigits,
        maximumFractionDigits: digits
    });
};

export const calculateIVSkew = (row) => {
    const calSpread = row.calendar_spread;
    if (!calSpread || !calSpread.legs || calSpread.legs.length < 2) return 'N/A';
    const frontIV = calSpread.legs[0]?.iv;
    const backIV = calSpread.legs[1]?.iv;
    if (typeof frontIV === 'number' && typeof backIV === 'number' && frontIV !== 0) {
        return 100 * (1 - (backIV / frontIV));
    }
    return 'N/A';
};

export const calculateStrikeDifference = (row) => {
    const verticalShortStrike = row.vertical_spread?.legs?.[0]?.strike || 0;
    const diagonalShortStrike = row.diagonal_spread?.legs?.[0]?.strike || 0;
    return Math.abs(verticalShortStrike - diagonalShortStrike);
};

export const getHedgeColor = (val) => {
    if (typeof val !== 'number' || val === 0) return 'inherit';
    return val < 0 ? 'var(--positive)' : 'var(--negative)';
};

export const getValColor = (val) => {
    if (typeof val !== 'number' || val === 0) return 'inherit';
    return val > 0 ? 'var(--positive)' : 'var(--negative)';
};
